import React from "react";
import { Typography } from "@mui/material";
import { HeaderBox } from "../styles/StyledComponents";

export default function Header() {
  return (
    <HeaderBox>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Assicurazione Casa
      </Typography>
      <Typography variant="body1" sx={{ opacity: 0.9, mb: 2 }}>
        Proteggi la tua abitazione e risparmia fino al 35%
      </Typography>
    </HeaderBox>
  );
}
